import flagsmith from 'flagsmith';

// Initialize Flagsmith with your client-side environment key
const FLAGSMITH_ENVIRONMENT_KEY = 'ZkTSbWcrrLFcU3MrByJYgY';

export const initializeFlagsmith = async (userId?: string) => {
  await flagsmith.init({
    environmentID: FLAGSMITH_ENVIRONMENT_KEY,
    identity: userId, // Optional: pass user ID for user-specific flags
    cacheFlags: true,
    enableAnalytics: false, // Set to true if you want analytics
  });
};

export const getFlagValue = (flagName: string): boolean => {
  return flagsmith.hasFeature(flagName);
};

export const getFlagValueWithDefault = (flagName: string, defaultValue: boolean = false): boolean => {
  try {
    return flagsmith.hasFeature(flagName);
  } catch (error) {
    console.warn(`Failed to get flag ${flagName}, using default:`, defaultValue);
    return defaultValue;
  }
};

export const getAllFlags = () => {
  return flagsmith.getAllFlags();
};

export const refreshFlags = async () => {
  await flagsmith.getFlags();
};

export default flagsmith;
